// @ts-nocheck
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
// import { BaseTheme } from "@insite/mobius/globals/baseTheme"; // bunzl custom code
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

// Valtech Custom Code --->
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { getSettingsCollection } from "@toolkit/Framework/Store/Context/ContextSelectors";
// <--- Valtech Custom Code

// Bunzl Custom Code --->
import useCategoryListCategories from "@store/Framework/Store/Data/Categories/useCategoryListCategories";
import BunzlStoreCategoryList from "@store/Library/Widgets/Category/BunzlStoreCategoryList";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { BaseTheme, ThemeTypography } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import parse from "html-react-parser";
import { categoryListStyles } from "@store/Overrides/Widgets/Category/CategoryList"; // Import styles
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import {
    CategoryListCommonFieldsProps,
    getSharedCategoryListFieldDefinitions,
} from "@store/Library/Widgets/Category/CategoryListFields";
// <--- Bunzl Custom Code

/* Bunzl Deleted code fields, moved to shared file */
// Bunzl Custom Code
interface Props extends WidgetProps, HasCategoryContext {
    fields: CategoryListCommonFieldsProps;
}

export interface CategoryDetailSubCategoriesStyles {
    container?: GridContainerProps;
    subCategoryItem?: GridItemProps;
    innerContainer?: GridContainerProps;
    subCategoryImageItem?: GridItemProps;
    subCategoryImageClickable?: ClickablePresentationProps;
    subCategoryImage?: LazyImageProps;
    subCategoryNameLinkItem?: GridItemProps;
    subCategoryNameLink?: LinkPresentationProps;
    /* Bunzl Custom Code Start */
    titleContentWrapper?: InjectableCss;
    title?: TypographyProps;
    content?: TypographyProps;
    /* Bunzl Custom Code End */
}

export const categoryDetailSubCategoriesStyles: CategoryDetailSubCategoriesStyles = {
    container: {
        gap: 0,
    },
    subCategoryItem: {
        width: [12, 12, 4, 4, 2],
        css: css`
            padding-bottom: ${pxToRem(30)};
        `,
    },
    innerContainer: {
        gap: 0,
    },
    subCategoryImageItem: {
        width: [2, 2, 12, 12, 12],
        css: css`
            width: 100%;
            padding: 0 ${pxToRem(8)} ${pxToRem(8)} ${pxToRem(8)};
        `,
    },
    subCategoryImageClickable: {
        css: css`
            width: 100%;
        `,
    },
    subCategoryImage: {
        css: css`
            img {
                height: 100%;
            }
        `,
    },
    subCategoryNameLinkItem: {
        width: [10, 10, 12, 12, 12],
        css: css`
            padding-bottom: ${pxToRem(8)};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                ])}
        `,
    },
    subCategoryNameLink: {
        css: css`
            width: 100%;
        `,
        color: "text.main",
        typographyProps: {
            weight: "bold",
            css: css`
                width: 100%;
                text-align: center;
                word-wrap: break-word;
            `,
        },
    },
    /* Bunzl Custom Code Start */
    titleContentWrapper: categoryListStyles.titleContentWrapper,
    title: categoryListStyles.title,
    content: categoryListStyles.content,
    /* Bunzl Custom Code End */
};

const styles = categoryDetailSubCategoriesStyles;

const CategoryDetailSubCategories = ({
    category,
    fields: {
        carouselOverflow,
        responsive,
        customCSS,
        gap,
        showArrows,
        linkText,
        numberOfItemsPerRow,
        useResponsiveOptions,
        /* Bunzl Custom Code Start */
        fromCategory,
        toCategory,
        title,
        titleType,
        titleStyle,
        content,
        showDots,
        /* Bunzl Custom Code End */
    },
}: Props) => {
    if (!category || !category.subCategoryIds || category.subCategoryIds.length === 0) {
        return null;
    }

    const categories = useCategoryListCategories();
    const customCssWrapper = css`
        ${customCSS}
    `;
    const titleStyles: TypographyProps = {
        ...styles.title,
        forwardAs: (titleType as keyof JSX.IntrinsicElements) || "h1",
        variant: (titleStyle as keyof ThemeTypography) || "h1",
    };

    return (
        <StyledWrapper css={customCssWrapper}>
            {/* Bunzl Custom Code Start */}
            {title || content ? (
                <StyledWrapper {...styles.titleContentWrapper}>
                    {title && (
                        <Typography {...titleStyles} className="category-list-title">
                            {title}
                        </Typography>
                    )}
                    {content && (
                        <Typography className="category-list-content" {...styles.content}>
                            {parse(content, parserOptions)}
                        </Typography>
                    )}
                </StyledWrapper>
            ) : null}
            {/* Bunzl Custom Code End */}
            <BunzlStoreCategoryList
                categories={categories}
                carouselOverflow={carouselOverflow}
                shouldUseResponsiveFields={useResponsiveOptions}
                responsiveFields={responsive}
                showArrows={showArrows}
                linkText={linkText}
                numberOfItemsPerRow={numberOfItemsPerRow}
                gap={gap}
                /* Bunzl Custom Code Start */
                showDots={showDots}
                fromCategory={fromCategory}
                toCategory={toCategory}
                /* Bunzl Custom Code End */
            />
        </StyledWrapper>
    );
};

const SubCategoryLinkView = ({
    category,
    showImages,
    defaultImagePath,
}: ReturnType<typeof mapStateToProps> & { showImages: boolean }) => {
    if (!category) {
        return null;
    }

    const imagePath = category.smallImagePath || defaultImagePath;

    return (
        <GridContainer {...styles.innerContainer}>
            {showImages && (
                <GridItem {...styles.subCategoryImageItem}>
                    {category.smallImagePath && (
                        <Clickable href={category.path} {...styles.subCategoryImageClickable}>
                            <LazyImage
                                src={category.smallImagePath}
                                altText={category.imageAltText}
                                {...styles.subCategoryImage}
                            />
                        </Clickable>
                    )}
                </GridItem>
            )}
            <GridItem {...styles.subCategoryNameLinkItem}>
                <Link
                    href={category.path}
                    {...styles.subCategoryNameLink}
                    data-test-selector={`categoryDetailsSubCategoriesLink_${category.id}`}
                >
                    {category.shortDescription}
                </Link>
            </GridItem>
        </GridContainer>
    );
};

const mapStateToProps = (state: ApplicationState, ownProps: { categoryId: string }) => ({
    category: getCategoryState(state, ownProps.categoryId).value,
    defaultImagePath: getSettingsCollection(state).extensionCatalogSettings?.notFoundCategorySmallImagePath,
});

const SubCategoryLink = connect(mapStateToProps)(SubCategoryLinkView);

const widgetModule: WidgetModule<FoundationFieldDefinition> = {
    component: withCategory(CategoryDetailSubCategories),
    definition: {
        group: "Category Details",
        icon: "list-ul",
        allowedContexts: ["CategoryDetailsPage"],
        /* Bunzl Custom Code - Moved Shared Field Definitions */
        fieldDefinitions: getSharedCategoryListFieldDefinitions(),
    },
};

export default widgetModule;
